import { render, staticRenderFns } from "./AdminSiteAuditLog.vue?vue&type=template&id=35f90882&scoped=true"
import script from "./AdminSiteAuditLog.vue?vue&type=script&lang=js"
export * from "./AdminSiteAuditLog.vue?vue&type=script&lang=js"
import style0 from "./AdminSiteAuditLog.vue?vue&type=style&index=0&id=35f90882&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f90882",
  null
  
)

export default component.exports